import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const PlusIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper aria-label="plus-icon" {...props} viewBox="0 0 24 24">
      <path
        fill="inherit"
        d="M10.588 4v6.588H4v2.824h6.588V20h2.824v-6.588H20v-2.824h-6.588V4z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgWrapper>
  );
};
